import React, { useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, Box
} from '@mui/material';
import sendRequest from '../utils/sendRequest';
import GavelIcon from '@mui/icons-material/Gavel';
import { MenuButtonIcon, SubmitButton, CancelButton, DangerButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function ApproveResolutionDialog({ po_doc_id, poName, addSnackbar, fetchPoDetails=null, fetchPos=null, isIcon=false }) {
  const [open, setOpen] = useState(false);
  const [loadingApproval, setLoadingApproval] = useState(false);
  const [loadingDenial, setLoadingDenial] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!loadingApproval && !loadingDenial) {
      setOpen(false);
    }
  };

  const approveResolution = async () => {
    setLoadingApproval(true);
    try {
      let response = await sendRequest(`purchase-orders/approve-resolution?po_doc_id=${po_doc_id}`);
      addSnackbar(response.message);
      handleClose();
      isIcon ? fetchPos() : fetchPoDetails();
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingApproval(false);
    }
  }

  const denyResolution = async () => {
    setLoadingDenial(true);
    try {
      let response = await sendRequest(`purchase-orders/deny-resolution?po_doc_id=${po_doc_id}`);
      addSnackbar(response.message);
      handleClose();
      isIcon ? fetchPos() : fetchPoDetails();
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingDenial(false);
    }
  }

  return (
    <Box>
      <MenuButtonIcon
        isIcon={isIcon}
        title={"Approve Resolution"}
        text={"Approve/Deny Order Resolution"}
        icon={GavelIcon}
        onClick={handleOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown={loadingApproval || loadingDenial}
      >
        <CustomDialogTitle
          header={"Approve/Deny Order Resolution"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>
            Is the Purchase Order completely resolved?
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{ display: 'flex', justifyContent: 'space-between', px: 3, pb: 2 }}
        >
          <CancelButton
            onClick={handleClose}
            disabled={loadingApproval || loadingDenial}
          >
            Cancel
          </CancelButton>

          <Box sx={{ display: 'flex', gap: 2 }}>
            <DangerButton
              showSpinner={loadingDenial}
              text={"Deny"}
              onClick={() => denyResolution()}
              disabled={loadingApproval || loadingDenial}
            />
            <SubmitButton
              showSpinner={loadingApproval}
              text={"Approve"}
              onClick={() => approveResolution()}
              disabled={loadingApproval || loadingDenial}
            />
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  )
}